import RemoveIcon from '@mui/icons-material/Remove';
import { IconButton, Stack } from '@mui/material';
import React from 'react';

interface MappingRowProps {
	children: React.ReactNode;
	onDelete: () => void;
	disableDelete?: boolean;
	disabled?: boolean;
}

const MappingRow: React.FC<MappingRowProps> = ({
	children,
	onDelete,
	disableDelete = false,
	disabled = false
}) => (
	<Stack
		data-testid="attribute-mapping-editor-row"
		direction="row"
		gap={4}
		my={1}
	>
		{children}
		<IconButton
			disabled={disableDelete || disabled}
			sx={{ visibility: disableDelete ? 'hidden' : 'unset' }}
			data-testid="attribute-mapping-editor-delete-mapping-button"
			onClick={onDelete}
		>
			<RemoveIcon />
		</IconButton>
	</Stack>
);

export default MappingRow;
